import { RecordTypesFinance } from '../enums/audit-trail.enum';
import { OptionDescription } from '../types/option.type';
import { fieldNameMapConfig } from "./audit-trail-config.data";
import { IAuditTrailAlignField } from "../interfaces";

const DETAILS_FIELDS_ALIGN: IAuditTrailAlignField[] = [{ fieldName: 'details', key: 'id', typeKey: 'number' }];
export const generalFieldsHide = [
  'id',
  'businessUnitId',
  'contact.id',
  'contactPerson.id',
  'salesperson.id',
  'billingAddress.id',
  'billingAddress.country',
  'billingAddress.postcode',
  'billingAddress.buildingName',
  'billingAddress.floor',
  'billingAddress.house',
  'billingAddress.street',
  'billingAddress.unit',
  'currencyRate',
  'invoiceType',
  'balanceDocumentCodeType',
  'template.id',
  'template.code',
  'details.id',
  'details.account.id',
  'details.accountId',
  'details.agent.id',
  'details.profitCenter.id',
  'details.discount',
  'details.gstCharged',
  'details.gstPercent',
  'details.gstValue',
  'details.invoiceCode',
  'details.total',
  'details.receiptMemoId',

  'postings.detailId',
  'postings.id',
  'postings.account.id',
  // 'postings.profitCenter.code',
  // 'postings.profitCenter.name',
  'postings.profitCenter.id',
  'postings.taxInvoiceId',
  'postings.invoiceCode',
  'postings.type',

  'creditNote.id',

  'company.id',
  'company.code',

  'journalPostings.account.id',
  'journalPostings.profitCenter.id',
  'reversalJournal.id',
  'account.id',
  'details.receiptId',
  'postings.receiptId',
  'details.receiptMemoType',
  'details.debit.subAmount',
  'details.debit.subTotalAmount',
  'details.debit.totalAmount',
  'details.credit.subAmount',
  'details.credit.subTotalAmount',
  'details.credit.totalAmount',

  'bankAccountId',
  'bankAccount.id',
  'accountId',
  'bankId',
  'bank.id',
  'directDebitCollectionFileId',
  'directDebitPaymentFileId',
  'directDebitCollectionFile.id',
  'directDebitPaymentFile.id',
  'paymentId',
  'supplierInvoices.id',
  'parentInvoice.id',
  'taxInvoices.id',
  'cheque.id',
  'cheque.amount',
  'cheque.chequeDate',
  'cheque.bankAccount.id',
  'cheque.bankAccount.bankAccountNumber',
  'cheque.bankAccount.name',
  'paymentBatchCode',
  'paymentBatchType',
  'details.paymentId',
  'details.debit.rateGroup.tax',
  'details.credit.rateGroup.tax',
  'details.isAdvance',
  'details.taxUnit',
  'parent.id',
  'parentId',
  'coaDisplayStatus.id',
  'category.id',
  'category.code',
  'receiveAccount.id',
  'paidAccount.id',
  'categoryId',
  'receiveAccountId',
  'paidAccountId',
  'user.id',
  'filters.contacts.id',
];

export const otherFieldsHide = [
  'discount',
  'amount',
  'gst',
  'paidAmount',
  'changeRequest.name.current',
  'changeRequest.name.request',
  'changeRequest.parentId.current',
  'changeRequest.parentId.request',
  'changeRequest.refCode.current',
  'changeRequest.refCode.request',
  'changeRequest.type.current',
  'changeRequest.type.request',
];

const COMMON_FIELDS = {
  'company.name': 'Company',
  'status': 'Status',
  'source': 'Source',
};

const DETAILS_FIELDS = {
  'details.itemCode': 'Item Code',
  'details.itemType': 'Item Type',
  'details.description': 'Description',
  'details.bankReferralFee': 'Bank Referral Fee',
  'details.type': 'Type',
  'details.account': 'Account Code',
  'details.account.code': 'Account Code',
  'details.account.name': 'Account Name',
  'details.quantity': 'Quantity',
  'details.uom': 'UOM',
  'details.unitPrice': 'Unit Price (SGD)',
  'details.gstCategory': 'GST Category',
  'details.gstInclusive': 'GST Inclusive',
  'details.amount': 'Amount',
  'details.remarks': 'Remarks',
  'details.profitCenter': 'Profit Center',
  'details.profitCenter.code': 'Profit Center Code',
  'details.profitCenter.name': 'Profit Center Name',
  'details.agent': 'Agent',
  'details.agent.businessName': 'Agent Business Name',
  'details.agent.nricName': 'Agent Nric Name',
  'details.agent.ceaRegNo': 'Agent CEA Reg No',
  'details.taxValue': 'GST (%)',
  'details.gstType': 'GST Inclusive',
  'details.debit.amount': 'Debit Amount',
  'details.credit.amount': 'Credit Amount',
  'details.transactionNo': 'Transaction No',
};

const POSTINGS_FIELDS = {
  'postings.account.code': 'Account Code',
  'postings.account.name': 'Account Name',
  'postings.account.normalizedAccountName': 'Account Code / Profit Centre',
  'postings.profitCenter': 'Profit Center',
  'postings.profitCenter.code': 'Profit Center Code',
  'postings.profitCenter.name': 'Profit Center Name',
  'postings.description': 'Description',
  'postings.currency': 'Currency',
  'postings.debit': 'Debit (SGD)',
  'postings.credit': 'Credit (SGD)',
  'postings.amount': 'Amount',
};

export const fieldNameMapTaxInvoice: { [key: string]: string } = {
  ...COMMON_FIELDS,
  'contact.name': 'General Info > Customer Name',
  'customerName': 'General Info > Supplier Name',
  'contact.code': 'General Info > Contact Code',
  'billingAddress.address': 'General Info > Billing Address',
  'contactPersonCustom': 'General Info > Contact Person',
  'contactPerson': 'General Info > Contact Person',
  'contactPerson.name': 'General Info > Contact Person',
  'paymentTerm': 'General Info > Payment Terms',
  'remarks': 'General Info > Remarks',
  'total': 'General Info > Total Amount',
  'balanceDue': 'General Info > Balance Due',
  'contact.gstRegNo': 'General Info > GST Registration',
  'gstRegNo': 'General Info > GST Registration',
  'invoiceNumber': 'General Info > Invoice Number',
  'invoiceDate': 'General Info > Invoice Date',
  'creditTerm': 'General Info > Credit Term (days)',
  'invoiceDueDate': 'General Info > Invoice Due Date',
  'supplierInvoiceType': 'General Info > Invoice Type',
  'ecbInvoiceDate': 'General Info > ECB Invoice Date',

  'salesperson': 'General Info > Salesperson',
  'salesperson.businessName': 'General Info > Salesperson Business Name',
  'salesperson.ceaRegNo': 'General Info > Salesperson CEA Reg No',
  'currency': 'General Info > Currency',
  'currencyCode': 'General Info > Currency',
  'gstPercent': 'General Info > GST',
  'reference': 'General Info > Reference',
  'paymentGeneratorNo': 'Payment Generator No.',
  'paymentDirectNo': 'Direct Debit Payment No.',
  'referenceNumber': 'Reference No',
  'createdMode': 'General Info > Confirmed',

  'billingAddressCustom': 'Other Details > Billing Address',
  'othersDescription': 'Other Details > Others Description',
  //'currencyRate': 'Currency Rate',
  'creditNote.creditNoteNumber': 'Credit Note Number',

  'details': 'Invoice Details > Item',
  ...DETAILS_FIELDS,
  'postings': 'Posting Details > Account Code',
  ...POSTINGS_FIELDS,
  'template.name': 'Print Format',
  'gstEdited': 'Edit Tax Value Checkbox',
  'fileAttachedViewName': 'Uploaded File',
}
export const fieldNameMapJournalEntries: { [key: string]: string } = {
  ...COMMON_FIELDS,
  'name': 'Journal Title',
  'code': 'Journal Number',
  'journalDate': 'Journal Date',
  'type': 'Type',
  'reversal': 'Reversal Journal Checkbox',
  'reversalJournal': 'Reversal Journal Number',
  'reversalJournal.name': 'Reversal Journal Title',
  'reversalJournal.code': 'Reversal Journal Number',
  'scheduleEnable': 'Enable Recurring Schedule',
  'scheduleName': 'Recurring Schedule > Task Name',
  'scheduleType': 'Recurring Schedule > Task Schedule',
  'scheduleStartDate': 'Recurring Schedule > Start Date',
  'scheduleEndDate': 'Recurring Schedule > End Date',
  'totalDebit': 'Total Debit',
  'totalCredit': 'Total Credit',
  'journalPostings': 'Posting Details',
  'journalPostings.account.code': 'Account Code',
  'journalPostings.account.name': 'Account Name',
  'journalPostings.description': 'Description',
  'journalPostings.profitCenter': 'Profit Center',
  'journalPostings.profitCenter.code': 'Profit Center Code',
  'journalPostings.profitCenter.name': 'Profit Center Name',
  'journalPostings.currency': 'Currency',
  'journalPostings.currencyRate': 'Currency Rate',
  'journalPostings.debit': 'Debit (SGD)',
  'journalPostings.credit': 'Credit (SGD)',
  'journalPostings.amount': 'Amount',

}

export const fieldNameMapReceipt: { [key: string]: string } = {
  ...COMMON_FIELDS,
  'type': 'Type',
  'mode': 'Receipt Mode',
  'code': 'General > Receipt Number',
  'referenceNumber': 'Reference No',
  'payerName': 'General > Payer\'s Name',
  'contact': 'General > Contact Code',
  'contact.code': 'General > Contact Code',
  'contact.name': 'General > Contact Name',
  'currency': 'General > Currency',
  'reference': 'General > Cheque No / Bank Ref / Transaction Number',
  'totalAmount': 'General > Total Amount',
  'receiptDate': 'General > Receipt Date',
  'account.code': 'General > Deposit Code',
  'account.name': 'General > Deposit Name',
  'details': 'Receipt Details',
  ...DETAILS_FIELDS,
  'details.taxAmount': 'Tax Amount',
  'details.isTaxable': 'Taxable Sales',
  'postings': 'Posting Details',
  ...POSTINGS_FIELDS
};

export const fieldNameMapBankAccount: { [key: string]: string } = {
  'company.name': 'Company',
  'account.code': 'Account Code',
  'account.name': 'Account Name',
  'account.normalizedAccountName': 'Account Code (Full)',
  'account': 'Account',
  'accountCode': 'Account Code',
  'bank.code': 'Bank Code',
  'bank.name': 'Bank Name',
  'bank': 'Bank',
  'name': 'Bank Account Name',
  'bankAccountNumber': 'Bank Account Number',
  'currency': 'Account Currency',
  'requireBankReturnCollectionFile': 'Required Bank Return File for Collection',
  'requireBankReturnPaymentFile': 'Required Bank Return File for Payment',
  'directDebitCollectionFile': 'Collection File',
  'directDebitCollectionFile.name': 'Collection File',
  'directDebitCollectionFile.fileName': 'Collection File',
  'directDebitPaymentFile': 'Payment File',
  'directDebitPaymentFile.name': 'Payment File',
  'directDebitPaymentFile.fileName': 'Payment File',
  'remarks': 'Remarks',
};

export const fieldNameMapChequeBooks: { [key: string]: string } = {
  'company.name': 'Company',
  'bankAccount.name': 'Bank Account Name',
  'bankAccount.bankAccountNumber': 'Bank Account Number',
  'bankAccount.bank.name': 'Bank Name',
  'chequeNumber': 'Cheque Number',
  'chequeDate': 'Cheque Date',
  'amount': 'Cheque Amount',
  'isCancel': 'Cancel',
  'paymentNumber': 'Payment Number',
  'paymentCode': 'Payment Number',
  'code': 'Code',
};

export const fieldNameMapSupplierCreditNote: { [key: string]: string } = {
  ...COMMON_FIELDS,
  'paidStatus': 'Status',
  'contact.name': 'General Info > Supplier Name',
  'billingAddress.address': 'General Info > Billing Address',
  'contactPerson.name': 'General Info > Contact Person',
  'contact.code': 'General Info > Contact Code',
  'invoiceNumber': 'General Info > Credit Note Number',
  'creditNoteNumber': 'General Info > Credit Note Number',
  'invoiceDate': 'General Info > Credit Note Date',
  'creditNoteDate': 'General Info > Credit Note Date',
  'creditTerm': 'General Info > Credit Term (days)',
  'currencyCode': 'General Info > Currency',
  'currency': 'General Info > Currency',
  'gstPercent': 'General Info > GST',
  'contact.gstRegNo': 'General Info > GST Registration',
  'gstRegNo': 'General Info > GST Registration',
  'reference': 'General Info > Reference',
  'parentInvoice': 'General Info > Tax Invoice Reference',
  'parentInvoice.invoiceNumber': 'General Info > Tax Invoice Reference',
  'supplierInvoices': 'General Info > Supplier Invoice',
  'supplierInvoices.invoiceNumber': 'Invoice Number',
  'supplierInvoices.invoiceDate': 'Invoice Date',
  'remarks': 'General Info > Remarks',
  'total': 'General Info > Total Amount',
  'balanceDue': 'General Info > Balance Due',
  'paymentGeneratorNo': ' Payment Generator No.',
  'paymentDirectNo': 'Direct Debit Payment No.',
  'referenceNumber': 'Reference No',

  'details': 'Credit Note Details > Item',
  ...DETAILS_FIELDS,
  'postings': 'Posting Details > Account Code',
  ...POSTINGS_FIELDS,
  'gstEdited': 'Edit Tax Value Checkbox',

};

export const fieldNameMapCreditNote: { [key: string]: string } = {
  'company.name': 'Company',
  'paidStatus': 'Status',
  'source': 'Source',
  'status': 'General Info > Status',
  'contact.name': 'General Info > Customer Name',
  'billingAddress.address': 'General Info > Billing Address',
  'contactPerson.name': 'General Info > Contact Person',
  'contact.code': 'General Info > Contact Code',
  'invoiceNumber': 'General Info > Credit Note Number',
  'creditNoteNumber': 'General Info > Credit Note Number',
  'invoiceDate': 'General Info > Credit Note Date',
  'creditNoteDate': 'General Info > Credit Note Date',
  'creditTerm': 'General Info > Credit Term (days)',
  'salesperson': 'General Info > Salesperson',
  'salesperson.businessName': 'General Info > Salesperson Business Name',
  'salesperson.ceaRegNo': 'General Info > Salesperson CEA Reg No',
  'currencyCode': 'General Info > Currency',
  'currency': 'General Info > Currency',
  'gstPercent': 'General Info > GST',
  'contact.gstRegNo': 'General Info > GST Registration',
  'gstRegNo': 'General Info > GST Registration',
  'reference': 'General Info > Reference',
  'parentInvoice.invoiceNumber': 'General Info > Tax Invoice Reference',
  'paymentTerm': 'General Info > Payment Terms',
  'remarks': 'General Info > Remarks',
  'creditNoteRemarks': 'General Info > Credit Note Remarks',
  'total': 'General Info > Total Amount',
  'balanceDue': 'General Info > Balance Due',
  'taxInvoices': 'General Info > Invoice Number',
  'taxInvoices.invoiceNumber': 'Invoice Number',
  'billingAddressCustom': 'Other Details > Billing Address',

  'paymentGeneratorNo': 'Payment Generator No.',
  'paymentDirectNo': 'Direct Debit Payment No.',
  'referenceNumber': 'Reference No',

  'details': 'Credit Note Details > Item',
  ...DETAILS_FIELDS,
  'postings': 'Posting Details > Account Code',
  ...POSTINGS_FIELDS,
  'gstEdited': 'Edit Tax Value Checkbox',
  'template.name': 'Print Format',

};

export const fieldNameMapPayment: { [key: string]: string } = {
  // General Info
  ...COMMON_FIELDS,
  'type': 'Type',
  'mode': 'Payment Mode',
  'payerName': 'General Info > Payee\'s Name',
  'contact.name': 'General Info > Contact Name',
  'contact.code': 'General Info > Contact Code',
  'reference': 'General Info > Cheque No / Bank Ref / Transaction Number',
  'code': 'General Info > Payment Number',
  'paymentDate': 'General Info > Payment Date',
  'currency': 'General Info > Currency',
  'totalAmount': 'General Info > Total Amount',
  'account.name': 'General > Payment Account Name',
  'account.code': 'General > Payment Account Code',
  'cheque': 'Cheque Number',
  'cheque.chequeNumber': 'Cheque Number',
  'referenceNumber': 'Reference No',
  'isSentMail': 'Email Status',
  //detail
  'details': 'Payment Items',
  ...DETAILS_FIELDS,
  'details.taxAmount': 'Amount Details',
  'details.isTaxable': 'Taxable Purchase',

  // Postings Table
  'postings': 'Posting Details',
  ...POSTINGS_FIELDS
};


export const fieldNameMapChartsOfAccounts: { [key: string]: string } = {
  ...COMMON_FIELDS,
  'role': 'Type',
  'type': 'Account Type',
  'code': 'Account Code',
  'name': 'Account Name',
  'refCode': 'Reference Code',
  'description': 'Description',
  'parent': 'Parent Account',
  'parent.code': 'Parent Account Code',
  'parent.name': 'Parent Account Name',

  'verifyStatus': 'Verification Status',
  'approvedAt': 'Approved Date',
  'rejectReason': 'Reject Reason',
  'rejectedAt': 'Reject Date',

  'normalizedAccountName': 'Account Code (Full)',
  'changeRequest': 'Changed value',
  'changeRequest.name.current': 'Changed Value > Account Name Current',
  'changeRequest.name.request': 'Changed Value > Account Name Request',
  'changeRequest.code.current': 'Changed Value > Account Code Current',
  'changeRequest.code.request': 'Changed Value > Account Code Request',
  'changeRequest.parentId.current': 'Changed Value > Parent Account Current',
  'changeRequest.parentId.request': 'Changed Value > Parent Account Request',
  'changeRequest.refCode.current': 'Changed Value > Reference Code Current',
  'changeRequest.refCode.request': 'Changed Value > Reference Code Request',
  'changeRequest.type.current': 'Changed Value > Account Type Current',
  'changeRequest.type.request': 'Changed Value > Account Type Request',
  'changeRequest.status.current': 'Changed Value > Account Status Current',
  'changeRequest.status.request': 'Changed Value > Account Status Request',
};

export const fieldNameMapAccountPeriods: { [key: string]: string } = {
  ...COMMON_FIELDS,
  'startDate': 'Period Start',
  'endDate': 'Period End',
  'type': 'Period Type',
};

export const fieldNameMapContact: { [key: string]: string } = {
  'company.name': 'Company',
  'status': 'Status',
  'name': 'Contact Name',
  'code': 'Contact Code',
  'category': 'Category',
  'category.name': 'Contact Category',
  'type': 'Customer / Supplier',
  'groupName': 'Group Name',
  'ceaRegNo': 'CEA Reg No.',
  'email': 'Email',
  'emails': 'Emails',
  'emails.email': 'Email',
  'phone.countryCode': 'Phone > Country Code',
  'phone.phoneNumber': 'Phone > Phone Number',
  'fax.countryCode': 'Fax > Country Code',
  'fax.phoneNumber': 'Fax > Phone Number',

  'businessRegNo': 'Business Registration',
  'creditTerm': 'Credit Term (days)',
  'creditLimit': 'Credit Limit',
  'gstRegistered': 'GST Registered',
  'gstRegNo': 'GST Registration',
  'remark': 'Remarks',

  'receiveAccount': 'Receivable Account',
  'receiveAccount.code': 'Receivable Account Code',
  'receiveAccount.name': 'Receivable Account Name',
  'accountReceivableCode': 'Receivable Account Code',
  'paidAccount': 'Payable Account',
  'paidAccount.code': 'Payable Account Code',
  'paidAccount.name': 'Payable Account Name',
  'accountPayableCode': 'Payable Account Code',
  'commerceDate': 'Commencement Date',
  'bankAccount': 'Bank Account',
  'bankAccount.accountNumber': 'Bank Account Number',
  'bankAccount.accountName': 'Bank Account Name',
  'bankAccount.bank.name': 'Bank Name',
  'isWithHold': 'Withhold',
  'bank.name': 'Bank Name',
  'bank.code': 'Bank Code',
  'accountName': 'Account Name',
  'accountNumber': 'Account Number',
  'remarks': 'Remarks',


  'addresses': 'Address',
  'addresses.address': 'Address',
  'addresses.country': 'Country',
  'addresses.type': 'Type',
  'addresses.postcode': 'Postcode',
  'addresses.district': 'District',
  'addresses.buildingName': 'Building Name',
  'addresses.floor': 'Floor',
  'addresses.house': 'Block No.',
  'addresses.street': 'Street Name',
  'addresses.unit': 'Unit No.',
  'addresses.default': 'Default',

  'persons': 'Contact Person',
  'persons.name': 'Name',
  'persons.email': 'Email',
  'persons.designation': 'Designation',
  'persons.phone': 'Phone',
  'persons.phone.countryCode': 'Phone > Country Code',
  'persons.phone.phoneNumber': 'Phone > Phone Number',
  'persons.mobile': 'Mobile',
  'persons.mobile.countryCode': 'Mobile > Country Code',
  'persons.mobile.phoneNumber': 'Mobile > Phone Number',
  'persons.fax': 'Fax',
  'persons.fax.countryCode': 'Fax > Country Code',
  'persons.fax.phoneNumber': 'Fax > Phone Number',
  'persons.default': 'Default',

};

export const fieldNameMapDebitNote: { [key: string]: string } = {
  'company.name': 'Company',
  'paidStatus': 'Status',
  'source': 'Source',
  'status': 'General Info > Status',
  'contact.name': 'General Info > Customer Name',
  'contact.code': 'General Info > Customer Code',
  'contact.normalizedName': 'General Info > Customer Name',
  'billingAddress.address': 'General Info > Billing Address',
  'contactPerson.name': 'General Info > Contact Person',
  'contactPerson.normalizedContactPersonName': 'General Info > Contact Person',
  'creditNoteNumber': 'General Info > Debit Note Number',
  'creditNoteDate': 'General Info > Debit Note Date',
  'creditNoteRemarks': 'General Info > Debit Note Remarks',
  'paymentTerm': 'General Info > Payment Term',
  'remarks': 'General Info > Remarks',

  'total': 'General Info > Total Amount',
  'balanceDue': 'General Info > Balance Due',
  'debitNoteNumber': 'General Info > Debit Note Number',
  'debitNoteDate': 'General Info > Debit Note Date',
  'creditTerm': 'General Info > Credit Term (days)',
  'salesperson': 'General Info > Salesperson',
  'salesperson.businessName': 'General Info > Salesperson Business Name',
  'salesperson.ceaRegNo': 'General Info > Salesperson CEA Reg No',
  'currencyCode': 'General Info > Currency',
  'currency': 'General Info > Currency',
  'gstRegNo': 'General Info > GST Registration',
  'gstPercent': 'General Info > GST',
  'reference': 'General Info > Reference',
  'billingAddressCustom': 'Other Details > Billing Address',

  'referenceNumber': 'Reference No',
  'template.name': 'Print Format',
  // Details Table
  'details': 'Debit Note Details',
  ...DETAILS_FIELDS,
  // Postings Table
  'postings': 'Posting Details',
  ...POSTINGS_FIELDS,
  'gstEdited': 'Edit Tax Value Checkbox',

};

export const fieldNameMapReversal: { [key: string]: string } = {
  // General Info
  ...COMMON_FIELDS,
  'type': 'Type',
  'mode': 'Payment Mode',
  'contact.name': 'General Info > Contact Name',
  'contact.code': 'General Info > Contact Code',
  'contactName': 'General Info > Contact\'s Name',
  'contactCode': 'General Info > Contact Code',
  'reference': 'General Info > Cheque No / Bank Ref / Transaction Number',
  'code': 'General Info > Reversal Number',
  'reversalDate': 'General Info > Reversal Date',

  'paymentDate': 'General Info > Payment Date',
  'currency': 'General Info > Currency',
  'totalAmount': 'General Info > Total Amount',
  'account.name': 'General Info > Bank Account Name',
  'account.code': 'General Info > Bank Account Code',
  'cheque': 'Cheque Number',
  'cheque.chequeNumber': 'Cheque Number',
  'referenceNumber': 'Reference No',

  'remark': 'General Info > Remarks',
  'total': 'General Info > Total Amount',
  'chequeNumber': 'General Info > Cheque Number',
  'receiptCode': 'General Info > Receipt Number',
  'paymentCode': 'General Info > Payment Number',

  //detail
  'details': 'Reversal Items',
  ...DETAILS_FIELDS,
  'details.taxAmount': 'Amount Details',
  'details.isTaxable': 'Taxable Purchase',
  // Postings Table
  'postings': 'Posting Details',
  ...POSTINGS_FIELDS

};

export const fieldNameMapPaymentGenerator: { [key: string]: string } = {
  ...COMMON_FIELDS,
  'code': 'Billing Number',
  'paymentDate': 'Payment Date',
  'payerName': 'Payee\'s Name',
  'currency': 'Currency',
  'remarks': 'Remarks',
  'status': 'Status',

  // fields
  'selectedDate': 'Data selection ran on',
  'receiptDateFrom': 'Receipt Date From',
  'receiptDateTo': 'Receipt Date To',
  'includeAdjustment': 'Include Adjustment',
  'includeMiscCreditNote': 'Include Miscellaneous Credit Note',
  'payProfitSharingonly': 'Pay Multi-Tier Only',
  'payNormalCommissionOnly': 'Pay Normal Comm Only',
  'excludePartialReceipt': 'Exclude Partial Receipt',
  'includeMiscLinkAr': 'Include Misc Credit Note (AR Reference)',
  'autoRunDataCompute': 'Auto-run Data Compute',
  'excludePayees': 'Exclude Payees',
  'includeTaxInvoices': 'Include Customer Invoices',
  'excludeTransactionCodes': 'Exclude Transactions',
  'includeTransactionCodes': 'Include Transactions',
  'excludeSupplierInvoices': 'Exclude Supplier Invoices',
  'excludeSupplierCreditNotes': 'Exclude Supplier Credit Notes',
  'paymentMode': 'Payment Method',
  'bankAccount': 'Bank Account',
  'bankAccount.bankAccountNumber': 'Bank Account No',
  'bankAccount.name': 'Bank Account Name',
  'chequeNumberFrom': 'Cheque No From',
  'submissionDate': 'Submission Date',
  'valueDate': 'Value Date',
  'description': 'Payment Details',
  'fileName': 'Bank File'
};

export const fieldNameMapPaymentDirect: { [key: string]: string } = {
  ...COMMON_FIELDS,
  'code': 'Direct Debit Payment No.',
  'paymentDate': 'Payment Date',
  'payerName': 'Payee\'s Name',
  'remarks': 'Remarks',
  'status': 'Status',
  'reference': 'Reference',
  'bankAccount': 'Bank Account',
  'bankAccount.bankAccountNumber': 'Bank Account No',
  'bankAccount.name': 'Bank Account Name',
  'submissionDate': 'Submission Date',
  'valueDate': 'Value Date',
  'description': 'Payment Details',
  'fileName': 'Bank File',
  'transactionCode': 'Transaction Code',
  'items': 'Invoice No',
};

export const fieldNameMapProfitCenter: { [key: string]: string } = {
  ...COMMON_FIELDS,
  'code': 'Profit Centre Code',
  'name': 'Profit Centre Name',
  'refCode': 'Reference Code',
  'parent': 'Sub-Centre For',
  'parent.code': 'Code',
  'parent.name': 'Name',
};

export const fieldNameMapAccountSetup = {
  ...COMMON_FIELDS,
  'usage': 'Control Account',
  'currency': 'Currency',
  'account.code': 'Account Code',
  'account.name': 'Account Name',
};

export const fieldNameMapStatementOfAccount = {
  ...COMMON_FIELDS,
  'code': 'Code',
  'filters.entityType': 'Entity Type',
  'filters.viewAt': 'View as At',
  'filters.contacts': 'Closing Agents / Customers',
  'filters.contacts.name': 'Name',
  'filters.contacts.code': 'Code',
  'filters.status': 'Closing Agent / Customer Status',
  'user.name': 'Action by',

};
export const fieldNameMapPaymentReminder = {
  'code': 'Code',
  'resaleCode': 'Transaction No',
  'invoiceNo': 'Invoice No',
  'invoiceCode': 'Invoice No',
  ...COMMON_FIELDS,
  'invoiceDate': 'Invoice Date',
  'clientName': 'Client Name',
  'outstandingAmount': 'Outstanding Amount',
  'dueDate': 'Due Date',
  'propertyAddress': 'Property Address',
  'closingAgent': 'Closing Agent',
  'resaleStatus': 'Transaction Status',
  'resaleType': 'Transaction Type',
  'leaseCommencementDate': 'Lease Commencement Date',
  'completionDate': 'Completion Date',
  'firstReminder': 'First Reminder',
  'finalReminder': 'Final Reminder',
  'lod': 'LOD',
  'firstReminderDueDate': 'First Reminder Due Date',
  'finalReminderDueDate': 'Final Reminder Due Date',
  'lodDueDate': 'LOD Due Date',
  'firstReminderIssuedDate': 'First Reminder Issued Date',
  'finalReminderIssuedDate': 'Final Reminder Issued Date',
  'lodIssuedDate': 'LOD Issued Date',
  'debtRecoveryOption': 'Debt Recovery Option',
  'effectiveDate': 'Effective Date',
  'agreementDate': 'Agreement Date',
  'reminderStatus': 'Reminder Status',
  'remarks': 'Remarks',
  'subject': 'Subject',
  'to': 'Send to',
  'date': 'Date',
  'stage': 'Stage',
  'emailType': 'Email Type',
  'isSkipped': 'Tab View',
  'fromStatus': 'From Status',
  'emailStatus': 'Email Status',

  'skip.firstReminderFirstSkipDueDate': 'First Reminder > 1st Skip Due Date',
  'skip.firstReminderSecondSkipDueDate': 'First Reminder > 2nd Skip Due Date',
  'skip.firstReminderFinalSkipDueDate': 'First Reminder > Final Skip Due Date',
  'skip.finalReminderFirstSkipDueDate': 'Final Reminder > 1st Skip Due Date',
  'skip.finalReminderSecondSkipDueDate': 'Final Reminder > 2nd Skip Due Date',
  'skip.finalReminderFinalSkipDueDate': 'Final Reminder > Final Skip Due Date',
  'skip.lodFirstSkipDueDate': 'LOD > 1st Skip Due Date',
  'skip.lodSecondSkipDueDate': 'LOD > 2nd Skip Due Date',
  'skip.lodFinalSkipDueDate': 'LOD > Final Skip Due Date',

  'skip.skipReasons.firstReminderFirstSkipReason': 'First Reminder > 1st Skip Reason',
  'skip.skipReasons.firstReminderSecondSkipReason': 'First Reminder > 2nd Skip Reason',
  'skip.skipReasons.firstReminderFinalSkipReason': 'First Reminder > Final Skip Reason',
  'skip.skipReasons.finalReminderFirstSkipReason': 'Final Reminder > 1st Skip Reason',
  'skip.skipReasons.finalReminderSecondSkipReason': 'Final Reminder > 2nd Skip Reason',
  'skip.skipReasons.finalReminderFinalSkipReason': 'Final Reminder > Final Skip Reason',
  'skip.skipReasons.lodFirstSkipReason': 'LOD > 1st Skip Reason',
  'skip.skipReasons.lodSecondSkipReason': 'LOD > 2nd Skip Reason',
  'skip.skipReasons.lodFinalSkipReason': 'LOD > Final Skip Reason',

  'firstReminderRevertReason': 'First Reminder Revert Reason',
  'finalReminderRevertReason': 'Final Reminder Revert Reason',
  'lodRevertReason': 'LOD Revert Reason',
  'reactivateReason': 'Reactivate Reason',
  'arbitrationIssueDate': 'Arbitration Issue Date',
  'mediationIssueDate': ' Mediation Issue Date',
  'writeOffDate': 'Write-Off Date',
  'writeOffReason': 'Write-Off Reason',
  'additionalDetails': 'Additional Details',

  'agent': 'Agent',
  'ceaNo': 'CEA No',
  'contactNo': 'Contact No',
  'email': 'Email Address',
  'isActive': 'No Reminder',
  'paymentDeadline': 'Payment Deadline',
};

export const RECORD_TYPES_FINANCE: Record<RecordTypesFinance, OptionDescription<RecordTypesFinance>> = {
  // [RecordTypesFinance.LedgerAccountEntity]: {
  //   id: RecordTypesFinance.LedgerAccountEntity,
  //   value: RecordTypesFinance.LedgerAccountEntity,
  //   name: 'CoA',
  //   viewValue: 'CoA',
  //   fieldNameMap: fieldNameMapChartsOfAccounts,
  //   fieldsHide: [...generalFieldsHide, 'approvedAt', 'changeRequest']
  // },
  [RecordTypesFinance.LedgerAccountLocalEntity]: {
    id: RecordTypesFinance.LedgerAccountLocalEntity,
    value: RecordTypesFinance.LedgerAccountLocalEntity,
    name: 'CoA - Local',
    viewValue: 'CoA - Local',
    fieldNameMap: fieldNameMapChartsOfAccounts,
    fieldsHide: [...generalFieldsHide, ...otherFieldsHide, 'approvedAt', 'changeRequest',]
  },
  [RecordTypesFinance.LedgerAccountMasterEntity]: {
    id: RecordTypesFinance.LedgerAccountMasterEntity,
    value: RecordTypesFinance.LedgerAccountMasterEntity,
    name: 'CoA - Master',
    viewValue: 'CoA - Master',
    fieldNameMap: fieldNameMapChartsOfAccounts,
    fieldsHide: [...generalFieldsHide, 'approvedAt']
  },
  [RecordTypesFinance.AccountSettingEntity]: {
    id: RecordTypesFinance.AccountSettingEntity,
    value: RecordTypesFinance.AccountSettingEntity,
    name: 'Account Setup',
    viewValue: 'Account Setup',
    fieldNameMap: { ...fieldNameMapConfig, ...fieldNameMapAccountSetup },
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesFinance.JournalEntity]: {
    id: RecordTypesFinance.JournalEntity,
    value: RecordTypesFinance.JournalEntity,
    name: 'Journal Entries',
    viewValue: 'Journal Entries',
    fieldNameMap: fieldNameMapJournalEntries,
    fieldsHide: [...generalFieldsHide, ...otherFieldsHide]
  },
  [RecordTypesFinance.AccountPeriodEntity]: {
    id: RecordTypesFinance.AccountPeriodEntity,
    value: RecordTypesFinance.AccountPeriodEntity,
    name: 'Accounting Periods',
    viewValue: 'Accounting Periods',
    fieldNameMap: fieldNameMapAccountPeriods,
    fieldsHide: [...generalFieldsHide, 'isOpen', 'code']
  },
  [RecordTypesFinance.ContactEntity]: {
    id: RecordTypesFinance.ContactEntity,
    value: RecordTypesFinance.ContactEntity,
    name: 'Customer/Supplier (General)',
    viewValue: 'Customer/Supplier (General)',
    fieldNameMap: fieldNameMapContact,
    fieldsHide: [...generalFieldsHide, 'addresses.type', 'email']
  },
  [RecordTypesFinance.ContactAddressEntity]: {
    id: RecordTypesFinance.ContactAddressEntity,
    value: RecordTypesFinance.ContactAddressEntity,
    name: 'Customer/Supplier (Address)',
    viewValue: 'Customer/Supplier (Address)',
    fieldNameMap: fieldNameMapContact,
    fieldsHide: [...generalFieldsHide, 'addresses.type', 'email']
  },
  [RecordTypesFinance.ContactPersonEntity]: {
    id: RecordTypesFinance.ContactPersonEntity,
    value: RecordTypesFinance.ContactPersonEntity,
    name: 'Customer/Supplier (Contact)',
    viewValue: 'Customer/Supplier (Contact)',
    fieldNameMap: fieldNameMapContact,
    fieldsHide: [...generalFieldsHide, 'addresses.type', 'email']
  },
  [RecordTypesFinance.ContactBankEntity]: {
    id: RecordTypesFinance.ContactBankEntity,
    value: RecordTypesFinance.ContactBankEntity,
    name: 'Customer/Supplier (Bank)',
    viewValue: 'Customer/Supplier (Bank)',
    fieldNameMap: fieldNameMapContact,
    fieldsHide: [...generalFieldsHide, 'addresses.type', 'email']
  },

  [RecordTypesFinance.CustomerInvoiceEntity]: {
    id: RecordTypesFinance.CustomerInvoiceEntity,
    value: RecordTypesFinance.CustomerInvoiceEntity,
    name: 'Tax Invoice',
    viewValue: 'Tax Invoice',
    fieldNameMap: fieldNameMapTaxInvoice,
    fieldsHide: [...generalFieldsHide, ...otherFieldsHide, 'contactPerson', 'contactPerson.name', 'createdMode'],
    fieldsAlign: DETAILS_FIELDS_ALIGN
  },
  [RecordTypesFinance.CreditNoteEntity]: {
    id: RecordTypesFinance.CreditNoteEntity,
    value: RecordTypesFinance.CreditNoteEntity,
    name: 'Credit Note',
    viewValue: 'Credit Note',
    fieldNameMap: fieldNameMapCreditNote,
    fieldsHide: [...generalFieldsHide, ...otherFieldsHide, 'amount', 'billingAddress', 'contactPersonCustom', 'contact', 'contactPerson'],
    fieldsAlign: DETAILS_FIELDS_ALIGN
  },
  [RecordTypesFinance.DebitNoteEntity]: {
    id: RecordTypesFinance.DebitNoteEntity,
    value: RecordTypesFinance.DebitNoteEntity,
    name: 'Debit Note',
    viewValue: 'Debit Note',
    fieldNameMap: fieldNameMapDebitNote,
    fieldsHide: [...generalFieldsHide, ...otherFieldsHide, 'amount', 'billingAddress', 'contactPersonCustom', 'contact', 'contactPerson', 'creditNoteRemarks'],
    fieldsAlign: DETAILS_FIELDS_ALIGN
  },
  [RecordTypesFinance.SupplierInvoiceEntity]: {
    id: RecordTypesFinance.SupplierInvoiceEntity,
    value: RecordTypesFinance.SupplierInvoiceEntity,
    name: 'Supplier Invoice',
    viewValue: 'Supplier Invoice',
    fieldNameMap: fieldNameMapTaxInvoice,
    fieldsHide: [...generalFieldsHide, ...otherFieldsHide, 'contact.name', 'contactPersonCustom', 'billingAddressCustom'],
    fieldsAlign: DETAILS_FIELDS_ALIGN
  },
  [RecordTypesFinance.SupplierCreditNoteEntity]: {
    id: RecordTypesFinance.SupplierCreditNoteEntity,
    value: RecordTypesFinance.SupplierCreditNoteEntity,
    name: 'Supplier Credit Note',
    viewValue: 'Supplier Credit Note',
    fieldNameMap: fieldNameMapSupplierCreditNote,
    fieldsHide: [...generalFieldsHide, ...otherFieldsHide, 'status', 'contactPerson', 'billingAddress'],
    fieldsAlign: DETAILS_FIELDS_ALIGN
  },
  [RecordTypesFinance.BankAccountEntity]: {
    id: RecordTypesFinance.BankAccountEntity,
    value: RecordTypesFinance.BankAccountEntity,
    name: 'Bank Account',
    viewValue: 'Bank Account',
    fieldNameMap: fieldNameMapBankAccount,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesFinance.ChequeBooksEntity]: {
    id: RecordTypesFinance.ChequeBooksEntity,
    value: RecordTypesFinance.ChequeBooksEntity,
    name: 'Cheque Books',
    viewValue: 'Cheque Books',
    fieldNameMap: fieldNameMapChequeBooks,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesFinance.ReceiptEntity]: {
    id: RecordTypesFinance.ReceiptEntity,
    value: RecordTypesFinance.ReceiptEntity,
    name: 'Receipts',
    viewValue: 'Receipts',
    fieldNameMap: fieldNameMapReceipt,
    fieldsHide: [...generalFieldsHide, ...otherFieldsHide, 'details.amount', 'contact.name'],
    fieldsAlign: DETAILS_FIELDS_ALIGN
  },
  [RecordTypesFinance.PaymentEntity]: {
    id: RecordTypesFinance.PaymentEntity,
    value: RecordTypesFinance.PaymentEntity,
    name: 'Payments',
    viewValue: 'Payments',
    fieldNameMap: fieldNameMapPayment,
    fieldsHide: [...generalFieldsHide, ...otherFieldsHide, 'contact'],
    fieldsAlign: DETAILS_FIELDS_ALIGN
  },
  [RecordTypesFinance.ReversalReceiptEntity]: {
    id: RecordTypesFinance.ReversalReceiptEntity,
    value: RecordTypesFinance.ReversalReceiptEntity,
    name: 'Reversal Receipts',
    viewValue: ' Reversal Receipts',
    fieldNameMap: fieldNameMapReversal,
    fieldsHide: [...generalFieldsHide, 'payerName'],
    fieldsAlign: DETAILS_FIELDS_ALIGN
  },
  [RecordTypesFinance.ReversalPaymentEntity]: {
    id: RecordTypesFinance.ReversalPaymentEntity,
    value: RecordTypesFinance.ReversalPaymentEntity,
    name: 'Reversal Payments',
    viewValue: 'Reversal Payments',
    fieldNameMap: fieldNameMapReversal,
    fieldsHide: [...generalFieldsHide, 'payerName'],
    fieldsAlign: DETAILS_FIELDS_ALIGN
  },
  [RecordTypesFinance.PaymentGeneratorEntity]: {
    id: RecordTypesFinance.PaymentGeneratorEntity,
    value: RecordTypesFinance.PaymentGeneratorEntity,
    name: 'Payment Generator',
    viewValue: 'Payment Generator',
    fieldNameMap: fieldNameMapPaymentGenerator,
    fieldsHide: [...generalFieldsHide, 'account', 'account.name', 'account.code', 'bankAccount.bankCode']
  },
  [RecordTypesFinance.PaymentDirectEntity]: {
    id: RecordTypesFinance.PaymentDirectEntity,
    value: RecordTypesFinance.PaymentDirectEntity,
    name: 'Direct Debit Payment',
    viewValue: 'Direct Debit Payment',
    fieldNameMap: fieldNameMapPaymentDirect,
    fieldsHide: [...generalFieldsHide, 'account', 'account.name', 'account.code']
  },
  [RecordTypesFinance.ProfitCenterEntity]: {
    id: RecordTypesFinance.ProfitCenterEntity,
    value: RecordTypesFinance.ProfitCenterEntity,
    name: 'Profit Center',
    viewValue: 'Profit Center',
    fieldNameMap: fieldNameMapProfitCenter,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesFinance.StatementOfAccountEntity]: {
    id: RecordTypesFinance.StatementOfAccountEntity,
    value: RecordTypesFinance.StatementOfAccountEntity,
    name: 'Statement Of Accounts',
    viewValue: 'Statement Of Accounts',
    fieldNameMap: fieldNameMapStatementOfAccount,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesFinance.ReceiptModeEntity]: {
    id: RecordTypesFinance.ReceiptModeEntity,
    value: RecordTypesFinance.ReceiptModeEntity,
    name: 'Receipt Mode',
    viewValue: 'Receipt Mode',
    fieldNameMap: fieldNameMapConfig,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesFinance.PaymentReminderEntity]: {
    id: RecordTypesFinance.PaymentReminderEntity,
    value: RecordTypesFinance.PaymentReminderEntity,
    name: 'Payment Reminder',
    viewValue: 'Payment Reminder',
    fieldNameMap: fieldNameMapPaymentReminder,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesFinance.PaymentReminderInfoEntity]: {
    id: RecordTypesFinance.PaymentReminderInfoEntity,
    value: RecordTypesFinance.PaymentReminderInfoEntity,
    name: 'Reminder Delivery',
    viewValue: 'Reminder Delivery',
    fieldNameMap: fieldNameMapPaymentReminder,
    fieldsHide: [...generalFieldsHide]
  },

};
